<template>

  <div id="dialog_receive_record">

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" height="250">
      <el-table-column fixed="right" label="操作" width="90">
        <template slot-scope="scope">
          <el-button
              v-if="scope.row.paymentStatus == '待支付'"
              @click="showImage(scope.row)"
              type="text"
              size="small"
          >付款码</el-button>
        </template>

      </el-table-column>

      <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip
          width="180"
      >
      </el-table-column>
      <el-table-column
          prop="paymentMethod"
          label="收款方式"
          show-overflow-tooltip
          width="80"
      >
      </el-table-column>
      <el-table-column
          prop="paymentStatus"
          label="收款状态"
          show-overflow-tooltip
          width="80"
      >
      </el-table-column>
      <el-table-column
          prop="money"
          label="收款总金额"
          show-overflow-tooltip
          width="110"
      >
      </el-table-column>
      <el-table-column
          prop="remainingAmount"
          label="剩余金额"
          show-overflow-tooltip
          width="80"
      >
      </el-table-column>
      <el-table-column
          prop="haveReceivedAmount"
          label="已领金额"
          show-overflow-tooltip
          width="80"
      >
      </el-table-column>
      <el-table-column
          prop="refundMoney"
          label="退款金额"
          show-overflow-tooltip
          width="80"
      >
      </el-table-column>
      <el-table-column
          prop="paymentAccountClientName"
          label="收款单位"
          show-overflow-tooltip
          width="220"
      >
      </el-table-column>
      <el-table-column
          prop="paymentTime"
          label="收款时间"
          show-overflow-tooltip
          width="180"
      >
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  props: {
    transactionData: {
      type: Object,
      default: function() {
        return;
      },
    },
    contractId: {
      type: String,
      default: function() {
        return;
      },
    },
  },
  data() {
    return {
      flag: false,
      loading: false,
      // isRotating: false, // 控制图标旋转状态
      data: this.transactionData,
      baseInfo: {},
      // remainingAmount: "", // 本次可领金额
      // voucherNo: "", // 确认回款交易单号
      // info: {
      //   type: "1", // 单号类型
      //   id: "", // 收款id
      //   money: "", // 回款金额
      //   account: "", // 收款单位
      //   receivedId: "", // 交易单号
      //   file: "", // 回款单附件
      // },
      tableData: [],
      // // 付款凭证信息
      // upload: {
      //   value: {
      //     flag: false,
      //     action: this.$fileBaseurl + "/uploadImageByMultipartFile",
      //     headers: {
      //       token: "95931b371eb64f4a9c862983ca8a5d15",
      //     },
      //     uploadParameter: {
      //       systemName: "finance",
      //       title: "付款凭证附件",
      //     },
      //   },
      // },
      // handlePreview(file) {
      //   // axios的基地址和上传文件路径同时存在时可预览
      //   if (this.$axios.defaults.baseURL && this.certificatePath) {
      //     window.open(
      //         this.$axios.defaults.baseURL + this.certificatePath,
      //         "_blank",
      //     );
      //   } else {
      //     this.$message.warning("暂不支持预览");
      //   }
      // },
    };
  },
  created() {},
  methods: {
    /**
     * 获取表格信息
     */
    initTableData() {
      // alert("ddddddddddddd")
      let requestData = {
        userId: this.baseInfo.userId,
        companyId: this.baseInfo.company.companyId,
        hasRemainingAmount: true, // 是否包含金额全部领取的,即是否包含总金额 == 已领金额
        currentPage: 1, // 当前页数
        pageSize: 15, // 每页条数
        // contractId: this.tempContract.id
        contractId: this.contractId
      };
      this.$request(
          "post",
          "/voucher/getAllVoucherList",
          requestData,
          (data) => {
            console.log(data);
            this.tableData = data.tableData;
            console.log("1111111111111111")
            console.log(data.tableData)
            console.log(this.tableData)
            console.log("22222222222222222")
          },
          (errorMessage) => {
            this.$message.error(errorMessage);
          },
      );
    },
    showImage(data) {
      // alert("showImage2222")
      this.$emit("showImage", data);
    },
    // /**
    //  * 点击搜索交易单号
    //  */
    // searchTransaction() {
    //   this.initTableData();
    // },
    // receive(row) {
    //   if (this.info.account == "") {
    //     this.$message({
    //       message: "收款单位不能为空!",
    //       type: "error",
    //       duration: 1000,
    //     });
    //     return;
    //   }
    //   if (this.info.money == "") {
    //     this.$message({
    //       message: "回款金额不能为空!",
    //       type: "error",
    //       duration: 1000,
    //     });
    //     return;
    //   }
    //   if (this.info.receivedId == "") {
    //     this.$message({
    //       message: "交易单号不能为空!",
    //       type: "error",
    //       duration: 1000,
    //     });
    //     return;
    //   }
    //   this.voucherNo = row.voucherNo;
    //   this.remainingAmount = row.remainingAmount;
    //   this.info.id = row.id;
    //   this.flag = true;
    // },
    // /**
    //  * 附件上传成功
    //  */
    // handleAvatarSuccess(response, file, fileList) {
    //   this.$message({
    //     message: "付款凭证上传成功!",
    //     type: "success",
    //     duration: 1000,
    //   });
    //   this.info.file = response.result.path;
    // },

    // /**
    //  * 刷新交易单号
    //  */
    // refresh() {
    //   this.isRotating = true; // 开始旋转动画
    //   this.$message.success("正在同步, 请耐心等待!");
    //   // 刷新收款单号
    //   let requestData = {};
    //   let end = new Date();
    //   let start = new Date();
    //   start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    //   requestData = {
    //     companyId: this.baseInfo.company.companyId,
    //     beginTime: this.$formatTime(start, "YYYY-MM-DD HH:mm:ss"),
    //     endTime: this.$formatTime(end, "YYYY-MM-DD HH:mm:ss"),
    //   };
    //
    //   this.$request(
    //       "post",
    //       "/voucher/synchronousReceivedInfo",
    //       requestData,
    //       (data) => {
    //         this.$message.success("收款记录同步成功!");
    //         // 延迟停止动画，确保用户看到完整的旋转效果
    //         setTimeout(() => {
    //           this.isRotating = false;
    //         }, 500);
    //       },
    //       (errorMessage) => {
    //         this.$message.error(errorMessage);
    //         this.loading = false;
    //         // 出错时也停止动画
    //         setTimeout(() => {
    //           this.isRotating = false;
    //         }, 500);
    //       },
    //   );
    // },
    /**
     * 确认回款
     */
    confirm() {
      let data = {
        money: this.info.money,
        service: this.data.options[0].value,
        account: this.info.account,
        receivedId: {
          id: this.info.id,
          voucherNo: this.voucherNo,
        },
        file: this.info.file,
      };
      this.$emit("confirm", data);
    },
    // changeType() {
    //   if (this.info.receivedId) {
    //     this.initTableData();
    //   } else {
    //     this.tableInfo.tableData = [];
    //   }
    // },
  },

  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.initTableData();
  },
};
</script>

<style lang="less" scoped>
#dialog_receive_record {
  width: 100%;

  height: auto;
  .el-row {
    display: flex;
    margin-bottom: 20px;
    min-height: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    .line {
      display: flex;
      align-items: center;
      .upload-img {
        margin: 0 2px;
      }
      .title {
        min-width: 100px;
        width: 25%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        margin-right: 5px;
        min-height: 30px;
      }
      .input {
        width: 18.2vw;
      }
      .dialog-content-line-value-but {
        width: auto;
        min-width: 70px;
        height: 30px;
        padding: 0 5px;
        margin-left: 5px;
        box-sizing: border-box;
        border: 1px solid @activeColor;
        color: @activeColor;
        font-size: 12px;
        border-radius: 3px;
        transition: 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          cursor: pointer;
          background-color: @activeColor;
          color: #fff;
        }
      }
    }
  }
  .divider {
    margin-top: 0;
  }
  .refresh {
    font-size: 12px;
    color: #5cb6ff;
    cursor: pointer;
    margin-left: 2px;
  }
}
#transaction_dialog {
  .dialog-line {
    display: flex;
    align-items: center;
    min-height: 25px;
    .dialog-title {
      margin-right: 2px;
    }
  }
  .last {
    display: flex;
    justify-content: end;
  }
}

// 添加旋转动画样式
.rotate-animation {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
